<div class="status-tracker-container">
  <app-dpr-status-tracker-grid
    [dprDetails]="dprDetails$ | async"
    [selectedSubproject]="selectedSubproject$ | async"
    [statusTracker]="statusTracker$| async"
    [colorTypes]="colorTypes$ | async"
    [gridData]="gridData$ | async"
    [canEdit]="canEdit"
    (gridRegistered)="onGridRegistered($event)"
    (formulaInputEdited)="onFormulaInputEdited($event)"
  ></app-dpr-status-tracker-grid>
</div>
